import { gql } from 'graphql-tag';

/**
 * 获取会员等级
 */
export const fetchGetOwnCustomLevelDocument = gql`
  query getOwnCustomlevel {
    getOwnCustomlevel {
      id
      level
      activated
      nextLevelConditios {
        condition {
          type
          value
          range {
            unit
            value
          }
        }
        conditionValues {
          tradeAmount
          tradeCount
        }
        passed
      }
      distributeRecords {
        type
        couponId
        value
        sourceId
      }
    }
  }
`;

/**
 * 获取会员等级配置
 */
export const fetchGetLevelConfigDocument = gql`
  query getLevelConfig {
    getLevelConfig {
      id
      levelsConfig {
        levels {
          name
          image
          description
          conditions {
            items {
              type
              value
              range {
                unit
                value
              }
            }
            judgeMethod
          }
          rights {
            type
            couponId
            value
          }
        }
      }
      customPageId
      enabled
    }
  }
`;

/**
 * 激活会员
 */
export const fetchActiveOwnCustomerLevelDocument = gql`
  mutation activeOwnCustomerLevel {
    activeOwnCustomerLevel {
      id
      level
      activated
      nextLevelConditios {
        condition {
          type
          value
          range {
            unit
            value
          }
        }
        conditionValues {
          tradeAmount
          tradeCount
        }
        passed
      }
    }
  }
`;

/**
 * 提交会员等级个人信息
 */
export const fetchUpdateMemberInfoDocument = gql`
  mutation updateMemberInfo($input: ActivateMembershipCardInput!) {
    updateMemberInfo(input: $input)
  }
`;
